/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getDocument = /* GraphQL */ `query GetDocument($s3Key: String!) {
  getDocument(s3Key: $s3Key) {
    s3Key
    timestamp
    status
    originalFileName
    ocrResult
    ocrJudgeResult
    errorMessage
    usedTemplateId
    reviewed
    reviewedAt
    reviewedBy
    documentAnchors
    templateMatchResult
    anchorTreeTrace
    webhookDelivery {
      state
      updatedAt
      lastAttemptAt
      httpStatus
      error
      targetHost
      targetSource
      trigger
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDocumentQueryVariables,
  APITypes.GetDocumentQuery
>;
export const listDocuments = /* GraphQL */ `query ListDocuments($status: String!, $limit: Int, $nextToken: String) {
  listDocuments(status: $status, limit: $limit, nextToken: $nextToken) {
    items {
      s3Key
      timestamp
      status
      originalFileName
      ocrResult
      ocrJudgeResult
      errorMessage
      usedTemplateId
      reviewed
      reviewedAt
      reviewedBy
      documentAnchors
      templateMatchResult
      anchorTreeTrace
      webhookDelivery {
        state
        updatedAt
        lastAttemptAt
        httpStatus
        error
        targetHost
        targetSource
        trigger
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDocumentsQueryVariables,
  APITypes.ListDocumentsQuery
>;
